
define('template!headerView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="sidebar-toggle" title="Menu">\n  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>\n</div>\n<div class="account-region"></div>\n<div class="languages-region"></div>\n<div class="search-region"></div>\n<div class="compuzz-region"></div>\n<div class="windows-tools-region"></div>\n';
 if (advancedMode) { ;
__p += '\n  <div class="users-region"></div>\n  <div class="designers-region"></div>\n';
 } ;
__p += '\n<div class="phone-region"></div>\n\n';
 if (displayChat) { ;
__p += '\n  <div class="chat-region"></div>\n';
 } ;
__p += '\n\n';
 if (displaySalesInbox) { ;
__p += '\n  <div class="sales-inbox-region"></div>\n';
 } ;
__p += '\n\n';
 if (displayNotifications) { ;
__p += '\n  <div class="notifications-region"></div>\n';
 } ;
__p += '\n\n';
 if (displayTasks) { ;
__p += '\n  <div class="tasks-region"></div>\n';
 } ;
__p += '\n\n';
 if (advancedMode) { ;
__p += '\n  <div class="second-screen-toggle" title="' +
((__t = ( _.i18n('header.secondScreen.activate', null, 'Use this tab as the second screen for Sales Inbox shortcuts.') )) == null ? '' : __t) +
'">\n    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line></svg>\n    <span class="dot" aria-hidden="true"></span>\n  </div>\n';
 } ;
__p += '\n\n<div class="theme-toggle" title="Toggle dark mode">\n  <svg class="icon-moon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path></svg>\n  <svg class="icon-sun" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line></svg>\n</div>\n<div class="user-region"></div>';

}
return __p
};});

